import React from "react";
import './accordion.css';
import Accordion from "./accordion";

export default function AccordionBlock({ accordions }) {
    return(
        <div className="container">
            <div className="accordionBlock">
                <div className="accordionColumn w-50">
                    {accordions.slice(0, 7).map((accordion, index) => (
                        <Accordion
                            key={accordion.id || index}
                            title={accordion.title}
                            body={accordion.body}
                            link={accordion.link}
                            download ={accordion.download}
                        />
                    ))}
                </div>
                <div className="accordionColumn w-50">
                    {accordions.slice(7, 15).map((accordion, index) => (
                        <Accordion
                            key={accordion.id || index}
                            title={accordion.title}
                            body={accordion.body}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}